module.exports = __webpack_public_path__ + "img/ro.22278e13.svg";